import { createContext } from 'react';
import { noop } from "lodash";
const TrackerContext = /*#__PURE__*/createContext(noop);
export default TrackerContext;
//# sourceMappingURL=context.js.map